import Vue from 'vue';

// 使用 Event Bus
const Eventbus = new Vue();

export default Eventbus;